<form>
  @if (!anyVariable()) {
  <div>
    {{ 'isothermalCharacterizationEdit.essays.empty' | translate }}
  </div>
  }

  @if (anyVariable()) {
  <mat-toolbar color="secondary" style="padding-left: 3em;">
    {{ 'isothermalCharacterizationEdit.calibration.title' | translate }}
  </mat-toolbar>
  }

  <br />

  <div fxLayout="column" fxLayout.xs="column" class="flexwrap">

    @for (tab of _variables; track tab; let indexVariable = $index) {
    <div fxFlex>
      <div fxLayout="column">
        @for (calibration of tab.calibrations; track calibration; let indexCalibration = $index) {
        <div fxFlex="100">
          <div fxFlex="100">
            <div fxFlex="85" class="flexwrap">
              <div fxFlex="20">
                <b style="margin: 0 auto; display: table; font-size: large;">
                  {{ 'variable.' + tab.translationVariable | translate }}
                  @if (!disableConfigureSensorsButton()) {
                  <mat-checkbox [(ngModel)]="tab.enableCalibration">
                  </mat-checkbox>
                  }
                </b>
              </div>
              @if (tab.enableCalibration) {
              <div fxFlex="20">
                <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
                  <div fxFlex="100">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'isothermalCharacterizationEdit.dialog.essay.calibrationName.label' | translate
                        }}</mat-label>
                      <input matInput name="calibrationName{{tab.idVariable}}" [(ngModel)]="calibration.calibrationName"
                        [disabled]="disableEdit()">
                    </mat-form-field>
                  </div>
                </div>
              </div>
              }
              <div fxFlex="60">
                <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
                  <div fxFlex="30">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'isothermalCharacterizationEdit.dialog.essay.setpoint.label' | translate
                        }}</mat-label>
                      <input matInput name="setpoint{{tab.idVariable}}" [(ngModel)]="tab.setpoint" required
                        pattern="(-?)[0-9]+([\.,][0-9]+)?" (blur)="updateTableUncertainty(indexVariable)"
                        [disabled]="disableEdit()">
                      <mat-error>
                        {{ 'isothermalCharacterizationEdit.dialog.essay.setpoint.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="20">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'isothermalCharacterizationEdit.dialog.essay.unit.label' | translate }}</mat-label>
                      <mat-select name="unit{{tab.idVariable}}" [(ngModel)]="tab.idUnit" required
                        [disabled]="!enableEditCriteria() || getVariableUnitsByVariable(tab.idVariable).length < 2"
                        (selectionChange)="onUnitChange(indexVariable, $event)">
                        @for (item of getVariableUnitsByVariable(tab.idVariable); track item) {
                        <mat-option [value]="item.id">
                          {{item.unit}}
                        </mat-option>
                        }
                      </mat-select>
                      <mat-error>
                        {{ 'isothermalCharacterizationEdit.dialog.essay.unit.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="40">
                    <div fxLayout="row">
                      <div fxFlex="70">
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{ 'isothermalCharacterizationEdit.dialog.essay.equipment.label' | translate
                            }}</mat-label>
                          <input matInput [ngModel]="calibration.equipmentName" [disabled]="disableSerialNumLabel()"
                            #trigger="matAutocompleteTrigger" [matAutocomplete]="auto" [required]="tab.enableCalibration"
                            (keyup)="lookupCalibrationEquipment(indexVariable, $event)" [disabled]="disableEdit()">
                          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn"
                            (optionSelected)='onSensorCalibrationChange(indexVariable, indexCalibration, $event, trigger)'>
                            @for (item of getResultsCalibrationLookup(tab.idVariable); track item; let index = $index) {
                            <mat-option [value]="item">
                              {{ item.name}} ({{item.serialNum}})
                            </mat-option>
                            }
                          </mat-autocomplete>
                          <mat-error>
                            {{ 'isothermalCharacterizationEdit.dialog.essay.sensors.serialNum.error' | translate }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      @if (calibration.equipmentName) {
                      <div fxFlex="10" fxFlex.lt-md="50%">
                        <button mat-icon-button color="primary" (click)="downloadCertificate(indexVariable, 0)">
                          <mat-icon>cloud_download</mat-icon>
                        </button>
                      </div>
                      }
                      @if (calibration.equipmentName && !disableEdit()) {
                      <div fxFlex="10" fxFlex.lt-md="50%">
                        <button mat-icon-button color="primary" (click)="clearSensorCalibration(indexVariable, 0)">
                          <mat-icon>clear</mat-icon>
                        </button>
                      </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              @if (tab.enableCalibration) {
              <div fxFlex="100">
                <div fxFlex="100" fxLayout="row" fxLayout.xs="column" class="flexwrap">
                  <div fxFlex="15">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'isothermalCharacterizationEdit.dialog.essay.uncertainty.label' | translate
                        }}</mat-label>
                      <input matInput name="uncertaintyCalibration{{tab.idVariable}}"
                        [(ngModel)]="calibration.uncertainty" (blur)="updateTableUncertainty(indexVariable)"
                        pattern="[0-9]+([\.,][0-9]+)?" required [disabled]="disableEdit()">
                      <mat-error>
                        {{ 'isothermalCharacterizationEdit.dialog.essay.sensors.uncertainty.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="15">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'isothermalCharacterizationEdit.dialog.essay.resolution.label' | translate
                        }}</mat-label>
                      <input matInput name="resolution{{tab.idVariable}}" [(ngModel)]="calibration.resolution" required
                        pattern="[0-9]+([\.,][0-9]+)?" (blur)="updateTableUncertainty(indexVariable)"
                        [disabled]="disableEdit()">
                      <mat-error>
                        {{ 'isothermalCharacterizationEdit.dialog.essay.resolution.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="10">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'isothermalCharacterizationEdit.dialog.essay.tolerance.label' | translate
                        }}</mat-label>
                      <input matInput name="tolerance{{tab.idVariable}}" [(ngModel)]="calibration.tolerance"
                        pattern="[0-9]+([\.,][0-9]+)?" (blur)="updateTableUncertainty(indexVariable)"
                        [disabled]="disableEdit()">
                    </mat-form-field>
                  </div>
                  <div fxFlex="15">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'isothermalCharacterizationEdit.dialog.essay.pattern.label' | translate
                        }}</mat-label>
                      <input matInput name="pattern{{tab.idVariable}}" [(ngModel)]="calibration.pattern"
                        (blur)="updateTableUncertainty(indexVariable)" type="number" required
                        [disabled]="disableEdit()">
                      <mat-error>
                        {{ 'isothermalCharacterizationEdit.dialog.essay.pattern.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="15">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'isothermalCharacterizationEdit.dialog.essay.average.label' | translate
                        }}</mat-label>
                      <input matInput name="average{{tab.idVariable}}"
                        [ngModel]="(calibration.average | number:'1.2-2')" disabled>
                    </mat-form-field>
                  </div>
                  <div fxFlex="15">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'isothermalCharacterizationEdit.dialog.essay.correction.label' | translate
                        }}</mat-label>
                      <input matInput name="correction{{tab.idVariable}}"
                        [ngModel]="(calibration.correction | number:'1.2-2')" disabled>
                    </mat-form-field>
                  </div>
                  <div fxFlex="15">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'isothermalCharacterizationEdit.dialog.essay.uncertaintyExpanded.label' | translate
                        }}</mat-label>
                      <input matInput name="uncertaintyExpanded{{tab.idVariable}}"
                        [ngModel]="(calibration.cPlusU | number:'1.2-2')" disabled>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              }
              @for (val of calibration.values; track val; let indexValue = $index) {
              <div fxFlex="10">
                @if (tab.enableCalibration) {
                <div fxLayout="row">
                  <div fxFlex="100">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'isothermalCharacterizationEdit.dialog.essay.value.label' | translate }} {{
                        indexValue
                        +
                        1 }}</mat-label>
                      <input matInput name="calibrationValue{{tab.idVariable}}{{indexValue}}" [(ngModel)]="val.value"
                        required (blur)="updateTableUncertainty(indexVariable)" type="number"
                        [disabled]="disableEdit()">
                      <mat-error>
                        {{ 'isothermalCharacterizationEdit.dialog.essay.value.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                }
              </div>
              }
              @if (tab.enableCalibration) {
              <div fxFlex="5" [fxShow]="indexVariable != 0" fxShow.lt-md="false">
              </div>
              }
            </div>
            @if (tab.enableCalibration) {
            <div fxFlex="10" fxLayout="column">
              <div fxFlex="100" fxLayout="row" fxLayout.xs="column">
                @if (tab.enableCalibration) {
                <div fxFlex="80" [fxShow]="indexVariable == 0" fxShow.lt-md="true">
                  @if (!disableEdit()) {
                  <button mat-raised-button color="accent" (click)="newValue(indexVariable)">
                    {{ 'button.new' | translate }}</button>
                  }
                </div>
                }
                @if (indexVariable == 0 && !disableEdit() && calibration.values?.length > 0) {
                <div fxFlex="20" fxFlex.lt-md="100%">
                  <button mat-icon-button color="accent" (click)="removeValue(indexValue)">
                    <mat-icon>clear</mat-icon>
                  </button>
                </div>
                }
              </div>
            </div>
            }
          </div>
        </div>
        }
      </div>
    </div>
    }

  </div>

  @if (anyVariableSelected()) {
  <table #uncertaintiesTable mat-table [dataSource]="getUncertaintiesList()" style="width: 100%;">
    <!-- Variable Column -->
    <ng-container matColumnDef="variable">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element">
        {{'variable.' + element.translationVariable | translate }}
      </td>
    </ng-container>
    <!-- Point Column -->
    <ng-container matColumnDef="point">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'calibrateEquipmentEdit.uncertainties.cols.average.label' | translate }} </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <span [matTooltip]="element.calibration?.average">
          <strong> {{ element.calibration?.average | number:'1.2-2' }} </strong>
        </span>
      </td>
    </ng-container>
    <!-- uRep Column -->
    <ng-container matColumnDef="uRep">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'calibrateEquipmentEdit.uncertainties.cols.uRep.label' | translate }} </th>
      <td mat-cell *matCellDef="let element">
        <span [matTooltip]="element.calibration?.uRep">
          {{ element.calibration?.uRep | number:'1.2-2' }}
        </span>
      </td>
    </ng-container>
    <!-- uResol Column -->
    <ng-container matColumnDef="uResol">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'calibrateEquipmentEdit.uncertainties.cols.uResol.label' | translate }} </th>
      <td mat-cell *matCellDef="let element">
        <span [matTooltip]="element.calibration?.uResol">
          {{ element.calibration?.uResol | number:'1.2-2' }}
        </span>
      </td>
    </ng-container>
    <!-- uPattern Column -->
    <ng-container matColumnDef="uPattern">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'calibrateEquipmentEdit.uncertainties.cols.uPattern.label' | translate }} </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.calibration?.uncertainty ? (element.calibration.uncertainty / 2) : null | number:'1.2-2' }}
      </td>
    </ng-container>
    <!-- uUnif Column -->
    <ng-container matColumnDef="uUnif">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'calibrateEquipmentEdit.uncertainties.cols.uUnif.label' | translate }} </th>
      <td mat-cell *matCellDef="let element">
        <span [matTooltip]="element.calibration?.uUnif">
          {{ element.calibration?.uUnif != null ? element.calibration.uUnif : 'common.notApplicable' | translate }}
        </span>
      </td>
    </ng-container>
    <!-- uEstab Column -->
    <ng-container matColumnDef="uEstab">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'calibrateEquipmentEdit.uncertainties.cols.uEstab.label' | translate }} </th>
      <td mat-cell *matCellDef="let element">
        <span [matTooltip]="element.calibration?.uEstab">
          {{ element.calibration?.uEstab | number:'1.2-2' }}
        </span>
      </td>
    </ng-container>
    <!-- uc Column -->
    <ng-container matColumnDef="uc">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'calibrateEquipmentEdit.uncertainties.cols.uc.label' | translate }} </th>
      <td mat-cell *matCellDef="let element">
        <span [matTooltip]="element.calibration?.uC">
          {{ element.calibration?.uC | number:'1.2-2' }}
        </span>
      </td>
    </ng-container>
    <!-- neff Column -->
    <ng-container matColumnDef="neff">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'calibrateEquipmentEdit.uncertainties.cols.neff.label' | translate }} </th>
      <td mat-cell *matCellDef="let element">
        <span [matTooltip]="element.calibration?.neff">
          {{ element.calibration?.neff | number:'1.0-0' }}
        </span>
      </td>
    </ng-container>
    <!-- k Column -->
    <ng-container matColumnDef="k">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'calibrateEquipmentEdit.uncertainties.cols.k.label' | translate }} </th>
      <td mat-cell *matCellDef="let element">
        <span [matTooltip]="element.calibration?.k">
          {{ element.calibration?.k }}
        </span>
      </td>
    </ng-container>
    <!-- U Column -->
    <ng-container matColumnDef="U">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'calibrateEquipmentEdit.uncertainties.cols.U.label' | translate }} </th>
      <td mat-cell *matCellDef="let element">
        <span [matTooltip]="element.calibration?.U">
          <strong> {{ element.calibration.U | number:'1.2-2' }} </strong>
        </span>
      </td>
    </ng-container>
    <!-- measureUnit Column -->
    <ng-container matColumnDef="measureUnit">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'calibrateEquipmentEdit.uncertainties.cols.measureUnit.label' | translate }} </th>
      <td mat-cell *matCellDef="let element"> {{ element.unitName }} </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="uncertaintiesCols"></tr>
    <tr mat-row *matRowDef="let row; columns: uncertaintiesCols;"></tr>
  </table>
  }

  @if (anyVariableSelected()) {
  <mat-toolbar color="secondary" style="padding-left: 3em;">
    {{ 'isothermalCharacterizationEdit.result.title' | translate }}
  </mat-toolbar>
  }


  <mat-tab-group style="width: 100%;" (selectedTabChange)="onVariableTabChange($event)">

    @for (tab of _variables; track tab; let indexVariable = $index) {
    <mat-tab label="{{'variable.' + tab.translationVariable | translate }}" style="min-height: 50vh;">
      <mat-toolbar color="secondary">
        {{ 'isothermalCharacterizationEdit.essays.criteriaTitle' | translate }}
        <button mat-icon-button color="accent" [disabled]="!enableEditCriteria()"
          (click)="openCreateCriteria(indexVariable)">
          <mat-icon>add</mat-icon>
        </button>
      </mat-toolbar>
      <div fxLayout="row" class="flexwrap">
        <div fxFlex>
          <table mat-table matSort #criteriaTable [dataSource]="tab.criterias" style="width: 95%;">
            <!-- criteria Column -->
            <ng-container matColumnDef="criteria">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'isothermalCharacterizationEdit.dialog.essay.criteria.cols.criteria' | translate }}
              </th>
              <td mat-cell *matCellDef="let item"> {{ showCriteria(item) }} </td>
            </ng-container>
            <!-- Button edit Column -->
            <ng-container matColumnDef="edit">
              <th mat-header-cell *matHeaderCellDef> {{ 'button.edit' | translate }} </th>
              <td mat-cell *matCellDef="let element; let criteriaIndex = index">
                @if (enableEditCriteria()) {
                <button mat-icon-button (click)="openEditCriteria(indexVariable, criteriaIndex)">
                  <mat-icon>mode_edit</mat-icon>
                </button>
                }
              </td>
            </ng-container>
            <!-- Button delete Column -->
            <ng-container matColumnDef="delete">
              <th mat-header-cell *matHeaderCellDef> {{ 'button.delete' | translate }} </th>
              <td mat-cell *matCellDef="let element; let criteriaIndex = index">
                @if (enableEditCriteria()) {
                <button mat-icon-button (click)="removeCriteria(indexVariable, criteriaIndex)">
                  <mat-icon>delete</mat-icon>
                </button>
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColsCriteria"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColsCriteria;"></tr>
          </table>
          <br />
        </div>
      </div>
      <mat-toolbar color="secondary">
        {{ 'isothermalCharacterizationEdit.essays.sensorsTitle' | translate }}
        @if (tab.id != null && !disableSerialNumLabel()) {
        <button mat-icon-button color="accent" (click)="openDialogCorrectSensors(indexVariable)"
          matTooltip="{{ 'executionEdit.dialog.correctSensor.title' | translate }}">
          <mat-icon class="mat-icon material-icons correctedSensorIcon">done_all</mat-icon>
        </button>
        }
        @if (idDisposal == null && !disableSerialNumLabel()) {
        <button mat-icon-button color="primary" (click)="uploadDisposalFile.click()"
          matTooltip="{{ 'button.uploadDisposal' | translate }}">
          <mat-icon class="opacity50">auto_awesome_mosaic</mat-icon>
        </button>
        }
        <input accept="image/*" hidden type="file" (change)="onUploadDisposal($event)" #uploadDisposalFile>
        @if (idDisposal != null && !disableSerialNumLabel()) {
        <button mat-icon-button color="accent" (click)="openDialogDisposal()"
          matTooltip="{{ 'button.uploadDisposal' | translate }}">
          <mat-icon>auto_awesome_mosaic</mat-icon>
        </button>
        }
        @if (idPhoto == null && !disableSerialNumLabel()) {
        <button mat-icon-button color="primary" (click)="uploadPhotoFile.click()"
          matTooltip="{{ 'button.uploadPhoto' | translate }}">
          <mat-icon class="opacity50">image</mat-icon>
        </button>
        }
        <input accept="image/*" hidden type="file" (change)="onUploadPhoto($event)" #uploadPhotoFile>
        @if (idPhoto != null && !disableSerialNumLabel()) {
        <button mat-icon-button color="accent" (click)="openDialogPhoto()"
          matTooltip="{{ 'button.uploadPhoto' | translate }}">
          <mat-icon>image</mat-icon>
        </button>
        }
      </mat-toolbar>
      <div fxLayout="row" class="flexwrap">
        <div fxFlex="100%">
          @for (sensor of tab.sensors; track sensor; let indexSensor = $index) {
          <div fxLayout="row" class="flexwrap">
            <div fxFlex="15" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'isothermalCharacterizationEdit.dialog.essay.sensors.sensorNum.label' | translate
                  }}</mat-label>
                <input matInput name="numSensor{{tab.idVariable}}{{indexSensor}}" value="{{ indexSensor + 1 }}"
                  disabled>
              </mat-form-field>
            </div>
            <div fxFlex="30" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'isothermalCharacterizationEdit.dialog.essay.sensors.location.label' | translate
                  }}</mat-label>
                <input matInput name="location{{tab.idVariable}}{{indexSensor}}" disabled
                  value="{{ showSensorName(indexVariable, sensor) }}">
              </mat-form-field>
            </div>
            <div fxFlex="25" fxFlex.lt-md="100%">
              <div fxLayout="row" class="flexwrap">
                @if (sensor.corrected) {
                <div fxFlex="20px" style="margin-top: 1em;margin-right: 1em;">
                  <mat-icon class="correctedSensorIcon"
                    matTooltip="{{ 'executionEdit.dialog.correctSensor.sensor.tooltip' | translate }}">done_all
                  </mat-icon>
                </div>
                }
                @if (!sensor.evaluate) {
                <div fxFlex="20px" style="margin-top: 1em;">
                  <span>❌</span>
                </div>
                }
                @if (sensor.outer) {
                <div fxFlex="20px" style="margin-top: 1em;">
                  <span>️☀️</span>
                </div>
                }
                <div fxFlex>
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'isothermalCharacterizationEdit.dialog.essay.sensors.serialNum.label' | translate
                      }}</mat-label>
                    <input matInput name="equipmentName{{tab.idVariable}}{{indexSensor}}"
                      [ngModel]="sensor.equipmentName" [disabled]="disableSerialNumLabel()"
                      #trigger="matAutocompleteTrigger" [matAutocomplete]="auto"
                      (keyup)="lookupEquipment(indexVariable, indexSensor, sensor.id, $event)">
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn"
                      (optionSelected)='onSensorChange(indexVariable, indexSensor, $event, trigger)'>
                      @for (item of getResultsLookup(sensor.id); track item; let index = $index) {
                      <mat-option [value]="item">
                        {{ item.name}} ({{item.serialNum}})
                      </mat-option>
                      }
                    </mat-autocomplete>
                    <mat-error>
                      {{ 'isothermalCharacterizationEdit.dialog.essay.sensors.serialNum.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div fxFlex="15" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'isothermalCharacterizationEdit.dialog.essay.sensors.uncertainty.label' | translate
                  }}</mat-label>
                <input matInput name="uncertainty{{tab.idVariable}}{{indexSensor}}" [ngModel]="sensor.uncertainty"
                  (blur)="setUncertainty(indexVariable, indexSensor, $event.target.value)"
                  [disabled]="disableSerialNumLabel()" required>
              </mat-form-field>
            </div>
            @if (!excelAlreadyUploaded(indexVariable, indexSensor) && showExcelButton(indexVariable, indexSensor)) {
            <button mat-icon-button [disabled]="disableUploadExcelButton() || sensor.id == null"
              (click)="uploadExcel.click()">
              <mat-icon style="max-height: 20px; vertical-align: text-bottom;"
                class="mat-icon material-icons {{ styleUploadOriginalButton(indexVariable, indexSensor) }}">
                insert_chart
              </mat-icon>
            </button>
            }
            @if (excelAlreadyUploaded(indexVariable, indexSensor) && showExcelButton(indexVariable, indexSensor)) {
            <button mat-icon-button (click)="openDialogSensorExcel(indexVariable, indexSensor)">
              <mat-icon class="mat-icon material-icons blueIcon">
                insert_chart
              </mat-icon>
            </button>
            }
            @if (!primaryAlreadyUploaded(indexVariable, indexSensor) && showPrimaryButton(indexVariable, indexSensor)) {
            <button mat-icon-button [disabled]="disableUploadOriginalButton() || sensor.id == null"
              (click)="uploadPrimaryFile.click()">
              <mat-icon style="max-height: 20px; vertical-align: text-bottom;" svgIcon="doc_lock"
                class="mat-icon material-icons {{ styleUploadOriginalButton(indexVariable, indexSensor) }}">
              </mat-icon>
            </button>
            }
            @if (primaryAlreadyUploaded(indexVariable, indexSensor) && showPrimaryButton(indexVariable, indexSensor)) {
            <button mat-icon-button (click)="openDialogSensorPrimary(indexVariable, indexSensor)">
              <mat-icon style="max-height: 20px; vertical-align: text-bottom;" svgIcon="doc_lock"
                class="mat-icon material-icons blueIcon"> </mat-icon>
            </button>
            }
            <button mat-icon-button (click)="showDialogConfigSensor(indexVariable, indexSensor)">
              <mat-icon style="max-height: 20px; vertical-align: text-bottom;" class="mat-icon material-icons">
                build
              </mat-icon>
            </button>
            <input accept=".xlsx, .xls, .csv, .pdf" hidden type="file"
              (change)="onExcelUploadSensor(indexVariable, indexSensor, $event)" #uploadExcel>
            <input accept="*" hidden type="file"
              (change)="onPrimaryDataUploadSensor(indexVariable, indexSensor, $event)" #uploadPrimaryFile>
          </div>
          }
        </div>
        <br />
        @if (tab.sensors?.length != 0) {
        <div fxLayout="row" class="flexwrap">
          @if (tab.idVariable != 1) {
          <div fxFlex="30" fxFlex.lt-md="100%">
            <mat-checkbox (change)="onCopyFromTemperatureChange(indexVariable, $event)"
              [checked]="tab.copyFromTemperature">
              {{ 'isothermalCharacterizationEdit.dialog.essay.copyFromTemperature.label' | translate }}
            </mat-checkbox>
          </div>
          }
          <div fxFlex="25" fxFlex.lt-md="100%">
            <mat-checkbox [value]="reasonModifyExpositionTime != null" [checked]="reasonModifyExpositionTime != null"
              [disabled]="!enableReasonModifyExpositionTime()" (change)="openReasonModifyExpositionTime($event)">
              {{ 'isothermalCharacterizationEdit.essays.allowEditGraph' | translate }}</mat-checkbox>
          </div>
          @if (tab.idVariable != 1) {
          <div fxFlex="5px"></div>
          }
          <div fxFlex></div>
          @if (!disableUploadExcelButton()) {
          <button mat-raised-button color="accent" (click)="uploadExcelMassive.click()"
            [disabled]="disableUploadExcelButton()">
            <mat-icon>insert_chart</mat-icon>
            {{ 'button.massive-upload-excel' | translate }}
          </button>
          }
          <input accept=".xlsx, .xls, .csv, .pdf" hidden type="file"
            (change)="onExcelMassiveUploadSensor(indexVariable, $event)" #uploadExcelMassive>
          <div fxFlex="5px"></div>
          @if (!disableUploadOriginalButton()) {
          <button mat-raised-button color="accent" (click)="openMassiveUploadPrimaryDataDialog(indexVariable)"
            [disabled]="disableUploadOriginalButton()">
            <mat-icon style="max-height: 20px; vertical-align: text-bottom;" svgIcon="doc_lock">
            </mat-icon>
            {{ 'button.massive-upload-primary' | translate }}
          </button>
          }
          <div fxFlex="5px"></div>
          @if (!disableUploadExcelButton()) {
          <button mat-raised-button color="accent" (click)="uploadAutomaticMassiveFile.click()"
            [disabled]="disableUploadExcelButton()">
            {{ 'button.massive-upload-automatic' | translate }}
          </button>
          }
          <input accept="*" hidden type="file" multiple (change)="uploadAutomaticMassive(indexVariable, $event)"
            #uploadAutomaticMassiveFile>
        </div>
        }
        <div fxFlex="5px"></div>
        @if (!disableConfigureSensorsButton()) {
        <button mat-raised-button (click)="openConfigureSensors()" color="accent">{{ 'button.configureSensors' |
          translate }}</button>
        }
        <div fxFlex="5px"></div>
        @if (!disableDefrostsButton()) {
        <button mat-raised-button (click)="showDialogDiscardTime(tab)" color="accent">
          {{ 'button.discardTimes' | translate }}</button>
        }
        <div fxFlex="5px"></div>
        <button mat-raised-button (click)="restartGraph(tab)" color="accent">
          {{ 'button.restartGraph' | translate }}</button>
      </div>
    </mat-tab>
    }

  </mat-tab-group>

  <app-isothermal-characterization-edit-graph (fcStartEssayEmitter)="onFcStartEssayEmit($event)"
    (copyDateFirstSensorEmitter)="onCopyTimeGraphChange($event)">
  </app-isothermal-characterization-edit-graph>
</form>